import React from 'react';
import { View, StyleSheet } from 'react-native';
import { theme } from '@garnish/constants';
import { DisplayText, BodyText } from '../Text';
import { BackButton } from '../BackButton';

export const MobileHeader = ({
  testID: baseTestID,
  titleTestID,
  subtitleTestID,
  backButtonTestID,
  title,
  subtitle,
  onClose,
}: MobileHeaderProps) => {
  return (
    <View testID={baseTestID ?? 'sg-mobile-header'}>
      {onClose ? (
        <BackButton
          testID={
            backButtonTestID ??
            baseTestID?.concat('.back-button') ??
            'sg-back-button'
          }
          icon="IconClose"
          containerStyle={styles.closeButton}
          onPress={onClose}
        />
      ) : null}
      {title ? (
        <DisplayText
          testID={titleTestID ?? baseTestID?.concat('.title')}
          size={3}
          style={[styles.title, !subtitle && styles.margin]}
        >
          {title}
        </DisplayText>
      ) : null}
      {subtitle ? (
        <BodyText
          testID={subtitleTestID ?? baseTestID?.concat('.subtitle')}
          size={4}
          style={[styles.subtitle, Boolean(subtitle) && styles.margin]}
        >
          {subtitle}
        </BodyText>
      ) : null}
    </View>
  );
};

type MobileHeaderProps = {
  readonly title?: string;
  readonly subtitle?: string;
  readonly onClose?: () => void;
  readonly testID?: string;
  readonly titleTestID?: string;
  readonly subtitleTestID?: string;
  readonly backButtonTestID?: string;
};

const styles = StyleSheet.create({
  closeButton: {
    paddingBottom: theme.spacing.xlarge - theme.spacing.xsmall,
    alignSelf: 'flex-end',
  },
  title: {
    fontSize: 32,
    paddingVertical: theme.spacing.small,
  },
  subtitle: {
    paddingVertical: theme.spacing.small,
  },
  margin: {
    marginBottom: theme.spacing.large,
  },
});
